import React from 'react';
import { Box, Typography } from '@mui/material';

const listItemStyle = {
    marginBottom: '0.75rem',
};

const IpAddressTypesSection = () => {
  return (
    <Box sx={{ px: { xs: 2, sm: 4 }, py: 2 }}>
      <Typography paragraph>
        WatchNod supports monitoring for both Public and Private/NAT IP addresses. Understanding their differences is essential for setting up accurate monitoring configurations.
      </Typography>

      {/* Public IP Address */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        Public IP Address
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Definition:</strong> A public IP address is assigned to a device or network by your Internet Service Provider (ISP). It is globally accessible over the internet.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Usage:</strong> These are used by servers, websites, and services that need to be reached from anywhere on the internet. Public IPs are essential for systems exposed to external users or clients.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Example:</strong> When you visit a website, your device connects to a server that has a public IP address. Similarly, your home router is usually assigned a public IP by your ISP.
          </Typography>
        </li>
      </ul>

      {/* Private IP Address */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        Private IP Address
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Definition:</strong> A private IP address is used within a local network and cannot be accessed directly from the internet. These are typically used by devices inside homes or corporate networks.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Usage:</strong> Devices such as laptops, printers, and phones communicate within the local network using private IPs.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Example:</strong> A typical private IP might look like 192.168.1.2, assigned by your home router to a device within your network.
          </Typography>
        </li>
      </ul>

      {/* Setup for Public-IP Monitoring */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        Setup for Public-IP Monitoring
      </Typography>
      <Typography paragraph>
        Public IP monitoring is used when you want to track services and systems that are exposed to the internet.
      </Typography>
      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        Prerequisites
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            You must have Node Exporter installed on the server you wish to monitor.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            The server must have a publicly accessible IP address.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Once these conditions are met, the IP can be added to WatchNod for monitoring through the Node Monitor Page.
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default IpAddressTypesSection;
